<template>
  <div>
    <StandardTable
      ref="table"
      :size="size"
      :rowKey="rowKey?rowKey:autoRowKey"
      :columns="columns"
      :pageNum="currentPage"
      :pageSize="currentPageSize"
      :data="loadDataRequest"
      :rowSelection="rowSelection"
      :childrenColumnName="childrenColumnName"
      :showPagination="!customPagination">
      <!-- 动态修改表头内容时columns对应列里面不能加title属性，否则不生效 -->
      <!-- slots: { title: 'ticketId' }-->
      <template v-for="(item, i) in headerRenders" :slot="item">
        <slot :name="item"></slot>
      </template>
      <template v-for="(item, i) in customRenders" :slot="item" slot-scope="text,record,index">
        <slot :name="item" :text="text" :record="record" :index="index"></slot>
      </template>
      <template :slot="expandedRowRender" slot-scope="record,index">
        <slot :name="expandedRowRender" :record="record" :index="index"></slot>
      </template>
      <template v-for="slotName in Object.keys($scopedSlots)" :slot="slotName" slot-scope="pageScope">
        <slot :name="slotName" v-bind="pageScope"/>
      </template>
    </StandardTable>
    <div class="custom-pagination-box" v-if="customPagination" ref="customPaginationTop">
      <div style="display: inline-block">
        <slot :name="extraPaginationName" :total="totalCount"/>
      </div>
      <div style="display: inline-block;float: right;" v-if="totalPage>1 && totalCount>currentPageSize">
        <a-pagination
          :total="totalCount"
          :showTotal="total => `总共 ${total} 条`"
          :pageSize="currentPageSize"
          showSizeChanger
          v-model="currentPage"
          @change="onPageChange"
          @showSizeChange="onShowSizeChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
//自定义分页加载组件（包装原始组件）
import { STable, Ellipsis } from '@/components'
import StandardTable from '@/customComponents/standard/StandardTable.vue'

export default {
  name: 'CustomPageTable',

  components: { STable, StandardTable },
  props: {
    rowKey: {
      type: String,
      default: ''
    },
    columns: {
      type: Array,
      default: function() {
        return []
      }
    },
    rowSelection: {
      type: Object,
      default: null
    },
    pageSize: {
      type: Number,
      default: 10
    },
    pageNum: {
      type: Number,
      default: 1
    },
    requestType: {
      type: String,
      default: 'post'
    },
    //查询式请求路径
    queryPath: {
      type: String,
      default: ''
    },
    //参数式请求路径
    paramsPath: {
      type: String,
      default: ''
    },
    //请求基础模块
    baseKey: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'default'
    },
    //请求的
    requestPromise: {
      type: Function,
      default: undefined
    },
    loadData: {
      type: Function,
      default: undefined
    },
    //查询参数
    queryParams: {
      type: Object,
      default: function() {
        return {}
      }
    },
    showResetButton: {
      type: Boolean,
      default: false
    },
    // 自定义分页显示
    customPagination: {
      type: Boolean,
      default: true
    },
    //分页附加信息
    extraPaginationName: {
      type: String,
      default: 'extraPaginationName'
    },
    childrenColumnName: {
      type: String,
      default: 'children'
    },
    expandedRowRender: {
      type: String,
      default: ''
    }
  },
  watch: {
    //当前页数变换监听
    'currentPage': function(newVal, oldVal) {
      this.$emit('pageChange', newVal)
    },
    'columns': function(columnsList) {
      this.customRenders = this.getCustomRendersList(columnsList)
      this.headerRenders = this.getHeaderRendersList(columnsList)
    },
    'pageSize': function(pageSize) {
      this.currentPageSize = pageSize
      setTimeout(() => this.refresh(true), 500)
    },
    'pageNum': function(pageNum) {
      this.currentPage = pageNum
      setTimeout(() => this.refresh(false), 500)
    }

  },
  data() {
    return {
      autoRowKey: 'autoRowKey',
      autoRowNum: 1,
      customRenders: [],
      headerRenders: [],
      currentPage: 1,
      currentPageSize: 10,
      totalCount: 0,
      totalPage: 0
    }
  },

  created() {
    this.currentPageSize = this.pageSize
  },
  mounted() {
    this.customRenders = this.getCustomRendersList(this.columns)
    this.headerRenders = this.getHeaderRendersList(this.columns)
  },
  methods: {
    loadDataRequest(parameter) {
      this.getLogUtils().logWithTag('parameter', parameter)
      return new Promise((resolve, reject) => {
        const result = this.loadData ? this.loadData(parameter) : this.getDefaultDataList(parameter)
        resolve(result)
      }).then(res => {
        this.currentPage = parameter.pageNo
        this.currentPageSize = parameter.pageSize
        this.totalCount = res.totalCount
        this.totalPage = res.totalPage
        return res
      })
    },

    getCustomRendersList(columnsList) {
      const customList = []
      if (columnsList && columnsList.length > 0) {
        columnsList.forEach((item, index, arr) => {
          // scopedSlots: { customRender: 'state' }
          if (item && item.scopedSlots && item.scopedSlots.customRender) {
            customList.push(item.scopedSlots.customRender)
          }
        })
      }
      return customList
    },
    getHeaderRendersList(columnsList) {
      const customList = []
      if (columnsList && columnsList.length > 0) {
        columnsList.forEach((item, index, arr) => {
          if (item && item.slots && item.slots.title) {
            customList.push(item.slots.title)
          }
        })
      }
      return customList
    },
    refresh(bool = false) {
      if (bool && this.customPagination) {
        //自定义分页 要在这里重置为第一页
        this.currentPage = 1
        setTimeout(() => this.$refs.table.refresh(bool), 200)
      } else {
        this.$refs.table.refresh(bool)
      }
    },
    //加载接口默认实现
    getDefaultDataList(parameter) {
      let requestPromise
      if ((this.queryPath || this.paramsPath) && this.requestType && this.baseKey) {//传统的老项目请求方式
        let path
        if (this.paramsPath) {
          path = this.paramsPath + '/' + parameter.pageNo + '/' + parameter.pageSize
        } else {
          path = this.queryPath + '?pageNum=' + parameter.pageNo + '&pageSize=' + parameter.pageSize
        }
        const baseService = this.getHttpServices().getCommonService(this.baseKey)
        requestPromise = this.requestType === 'post' ? baseService.post(path, this.queryParams) : baseService.get(path, this.queryParams)
      } else {
        let requestParams
        if (this.requestType === 'post') {
          requestParams = {
            ...this.queryParams,
            limitDto: {
              pageNum: parameter.pageNo,
              pageSize: parameter.pageSize
            }
          }
        } else {
          requestParams = {
            pageSize: parameter.pageSize,
            pageNum: parameter.pageNo,
            ...this.queryParams
          }
        }
        this.getLogUtils().logWithTag('requestParams', requestParams)
        requestPromise = this.requestPromise(requestParams, parameter)
      }

      return requestPromise.then(res => {
        if (!this.rowKey && res.data && res.data.length > 0) {
          //没有传key，则自动构建一个唯一的可以
          for (let i = 0, len = res.data.length; i < len; i++) {
            this.autoRowNum = this.autoRowNum + i
            res.data[i][this.autoRowKey] = this.autoRowKey + this.autoRowNum
          }
        }
        return {
          pageSize: parameter.pageSize,
          pageNo: parameter.pageNo,
          totalCount: res.totalCount,
          totalPage: res.pageCount,
          data: res.data
        }
      }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
        return {
          pageSize: parameter.pageSize,
          pageNo: parameter.pageNo,
          totalCount: 0,
          totalPage: 0,
          data: []
        }
      })
    },

    onShowSizeChange(current, pageSize) {
      this.currentPage = current
      this.currentPageSize = pageSize
      this.$emit('changePageParameter') //修改可变参数
      setTimeout(() => this.refresh(true), 500)
    },
    onPageChange(page, pageSize) {
      this.currentPage = page
      this.currentPageSize = pageSize
      this.$emit('changePageParameter')//修改可变参数
      setTimeout(() => this.refresh(false), 500)
    },
    updateSelect(selectedRowKeys, selectedRows) {
      this.$refs.table.updateSelect(selectedRowKeys, selectedRows)
    }
  }

}
</script>
<style scoped lang="less">
.custom-pagination-box {
  margin-top: 20px;
  height: 40px;
  width: 100%;
  line-height: 40px;
}
</style>